import {create} from 'zustand';
import { IAccount } from '@/types/account';

export type IAppState = {
  profile: IAccount | null;
  loading: boolean;
};

export const AppState: IAppState = {
  profile: null,
  loading: true,
};

// Тип состояния приложения.
type IAppStore = {
  appState: IAppState;
  setProfile: (payload: Partial<IAccount | null>) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
};

// Создание store.
export const useAppStore = create<IAppStore>()(
  (set) => ({
    appState: AppState,
    // Обновление информации о пользователе.
    setProfile: (payload) =>
      set((state) => ({
        appState: {
          ...state.appState,
          profile: payload ? { ...payload } as IAccount : null,
        },
      })),
    // Выход.
    logout: () =>
      set((state) => ({
        appState: {
          ...state.appState,
          profile: null,
        },
      })),
    // Обновление состояния загрузки.
    setLoading: (loading) =>
      set((state) => ({
        appState: {
          ...state.appState,
          loading: loading
        },
      })),
  }),
);
